import { useEffect, useState } from "react";

export const CONTACT = {
  email: "partnerships@vdyo.studio",
  whatsapp: "917011353855",
  whatsappDisplay: "+91 70113 53855",
  phone: "+917011353855",
  phoneDisplay: "+91 70113 53855",
  whatsappLink:
    "https://wa.me/917011353855?text=" +
    encodeURIComponent("Hi VDYO — I have footage for one video. What does working together look like?"),
  freeEditLink:
    "https://wa.me/917011353855?text=" +
    encodeURIComponent("Hi VDYO — I'd like the free 30-second edit. Where do I send the footage?"),
  instagram: "https://instagram.com/vdyo.studio",
  instagramHandle: "@vdyo.studio",
};

export const FREE_EDIT_LABEL = "Get a free 30-second edit";

export const BRAND_FILM = {
  id: "brand-film",
  guid: "brand-film",
  youtubeId: "avOwkmepZTM",
  aspect: "16:9",
  industry: "VDYO",
  capability: "The brand film",
  duration: "40s",
};

export const youtubeEmbed = (id, { muted = false } = {}) =>
  `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1` +
  (muted ? `&mute=1&loop=1&playlist=${id}&controls=0&disablekb=1` : "");

export const FORMATS = [
  "Talking Head", "Podcast Clips", "Product Videos", "Ad Creatives", "UGC",
  "YouTube Long Form", "Reels", "Testimonials", "Explainers", "Event Recaps",
  "Course Content", "Motion Graphics", "Brand Films", "Property Walkthroughs",
  "Store & Space Tours", "Trend Edits", "Founder Videos", "Before & After Edits",
  "Screen Recordings", "Demo Videos", "Shorts", "Interview Edits",
  "Behind The Scenes", "Recipe & Food Videos", "Fashion Lookbooks",
  "Company Profiles", "Webinar Edits", "Sizzle Reels", "Showreels",
  "Announcement Videos", "Festive & Campaign Edits", "Faceless Videos",
  "AI-Assisted Ads", "Voiceover Videos", "Photo-to-Video", "Subtitles & Captions",
  "Colour Grading", "Sound Design", "Thumbnails",
];

export const FAQS = [
  {
    q: "Who covers when someone's on leave?",
    a: "The team does. Your account lead holds the brief, and the editors behind them work from the same documented standard. Leave, illness, a launch week — your delivery window doesn't move.",
  },
  {
    q: "What do you need from me to get started?",
    a: "One call and one brief. References, brand kit, the formats you need and roughly how many videos a month. We write it down once. After that, it's raw footage in a shared folder.",
  },
  {
    q: "Can I have the project files?",
    a: "Yes. Ask and we hand them over — timelines, assets, everything. Your footage, your edits, your files.",
  },
  {
    q: "Do you white label for agencies? Do you sign NDAs?",
    a: "Yes to both. Your brief, our team, your name on the delivery. NDAs are signed before we see a frame, and your clients never hear our name unless you want them to.",
  },
  {
    q: "How do revisions work?",
    a: "Two rounds are included in every video. Tell us what's off — pacing, music, captions, colour — and we recut. No scope arguments, no surprise line items.",
  },
  {
    q: "Is there a minimum commitment?",
    a: "No. Per video, you send one and pay for one. Monthly plans run month to month and you can pause or stop with a message. The free 30-second edit has no strings either.",
  },
  {
    q: "How does payment work?",
    a: "Per video is billed on delivery. Monthly plans are billed at the start of the month for a fixed output. Bank transfer, UPI or card — whichever is easier for you.",
  },
  {
    q: "Which time zones do you cover?",
    a: "We're based in Delhi (IST) and work with clients in India and abroad. Delivery windows are agreed in your time zone, and your account lead is reachable during your working hours.",
  },
];

export const COMPARISON = {
  cols: ["Freelancer", "In-house editor", "VDYO"],
  rows: [
    ["Best when", "One project, clear brief", "High volume, strong brand voice", "Steady output without a hire"],
    ["Cost shape", "Per video", "Salary, software, downtime", "Per video or fixed monthly"],
    ["Range of formats", "Their speciality, done well", "Their speciality, done well", "Every format, in-house"],
    ["Cover when someone's away", "You reschedule", "You reschedule", "The team covers it"],
    ["Scaling for a launch", "Find another freelancer", "Not really possible", "Same week"],
    ["Brief handling", "Direct to the editor", "Direct to the editor", "One lead, brief documented"],
    ["Brand depth", "Grows over time", "Deepest, by far", "Locked in after month one"],
  ],
};

let videoCache = null;
export function useVideos() {
  const [videos, setVideos] = useState(videoCache || []);
  useEffect(() => {
    if (videoCache) return;
    fetch("/videos.json")
      .then((r) => r.json())
      .then((d) => {
        videoCache = d;
        setVideos(d);
      })
      .catch(() => {});
  }, []);
  return videos;
}

export const slug = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Round-robin across capabilities so the mosaic never clumps one kind together.
export const distribute = (list) => {
  const groups = {};
  list.forEach((v) => {
    (groups[v.capability] = groups[v.capability] || []).push(v);
  });
  const keys = Object.keys(groups);
  const out = [];
  let i = 0;
  while (out.length < list.length) {
    const k = keys[i % keys.length];
    if (groups[k].length) out.push(groups[k].shift());
    i++;
  }
  return out;
};
